module.exports = __webpack_public_path__ + "img/appltCourse-img32.21d3c302.png";